import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";

const MAKEUP_CONTINUE_URL = "/makeup-3month-29-upsell-v2";

const MAKEUP_PROGRESS_STEPS = [
  { threshold: 10, label: "Scanning your face shape and proportions" },
  { threshold: 35, label: "Checking undertone, contrast, and color depth" },
  { threshold: 60, label: "Mapping makeup placement" },
  { threshold: 85, label: "Matching flattering lip, eye, and cheek colors" },
  { threshold: 100, label: "Preparing your personalized makeup match" },
];

const FaceMeshMakeupV2Page = () => {
  return (
    <FaceMeshAsyncV2Page
      analyticsPrefix="facemesh_makeup_v2"
      continueUrl={MAKEUP_CONTINUE_URL}
      missingImageHelpPath="/facemesh-makeup-v2"
      pagePath="/facemesh-makeup-v2"
      progressSteps={MAKEUP_PROGRESS_STEPS}
      heading={
        <>
          For accurate makeup matching,
          <br />
          we analyze your face shape and color type
        </>
      }
      progressTitle="Makeup match progress"
      preparingText="Preparing your makeup analysis..."
      finalizingText="Finalizing your makeup match..."
      documentTitle="AI Makeup Match"
    />
  );
};

export default FaceMeshMakeupV2Page;
